module.exports = __webpack_public_path__ + "img/2.1abd6e95.png";